import Popin from './popin';

export default popinTrigger => {
    // console.log('popinTrigger');

    popinTrigger.addEventListener('click', event => {
        Popin({
            id: event.target.getAttribute('data-popin'),
        });
    });
};
